import { useAppSelector } from '@hooks/reduxHooks';
import { $api } from '@service/RequestService';
import { useQuery } from 'react-query';

import { UserType } from '../models';

export function useAllUsers(search?: string) {
  const userId = useAppSelector(state => state.userReducer.user?.id);
  const visible = useAppSelector(state => state.dashboardReducer.visibleShareDashboard);

  const { data, ...arg } = useQuery<{ users: UserType[] }>(
    ['dashboard-v2-all-users'],
    async () => {
      const { data } = await $api.get('/v1/lead/employee/all');

      return { users: data?.data };
    },
    {
      enabled: visible,
      select: ({ users }) => ({
        users: users
          ?.filter(({ id }) => id !== userId)
          ?.filter(({ fullName }) => (search ? fullName?.toUpperCase()?.includes(search?.toUpperCase()) : true))
      })
    }
  );

  return { ...data, ...arg };
}
